{
  "people": "Leute",
  "teams": "Mannschaften",
  "surnameAlphabetical": "Familienname A-Z",
  "teamsAlphabetical": "Teams A-Z",
  "addTeamMember": "Teammitglied hinzufügen",
  "addSelectedToTeam": "Ausgewähltes zum Team hinzufügen",
  "allPeople": "Alle Leute",
  "removeTeamLeaderMessage": "Diese Person kann keine Teammitglieder mehr bearbeiten und hinzufügen/entfernen.",
  "removeTeamLeader": "Den Teamleiter-Status entfernen",
  "addTeamLeaderMessage": "Diese Person kann Teammitglieder bearbeiten und hinzufügen/entfernen.",
  "addTeamLeader": "Teamleiter-Status hinzufügen",
  "add_people": {
    "add_user": "Benutzer hinzufügen",
    "invite_people_to_the_project": "Senden Sie Einladungen, um dem Projekt beizutreten",
    "email": "E-Mail",
    "team": "Mannschaft",
    "separate_comma": "Trennen Sie mehrere Adressen durch ein Komma",
    "add_invitee_team": "Fügen Sie Eingeladene (n) zu einem Team hinzu",
    "add_more": "Füge mehr hinzu",
    "project_admin": "Administrator des Projekts",
    "sso": "SSO aktivieren"
  },
  "remove_people": {
    "remove_user": "Benutzer entfernen",
    "remove_user_title": "Diesen Benutzer aus dem Projekt entfernen",
    "remove_user_message": "Dadurch wird das Konto des ausgewählten Benutzers im Projekt deaktiviert und er kann sich nicht mehr anmelden.",
    "remove_user_message_continue": "Sind Sie sicher, dass Sie fortfahren möchten?",
    "remove_people_success": "Der Benutzer wurde erfolgreich aus dem Projekt entfernt"
  },
  "reset_password": {
    "reset_password_title": "Link zum Zurücksetzen des Passworts senden",
    "reset_password_message": "Dadurch wird ein Link zum Zurücksetzen des Passworts an die von Ihnen ausgewählten Personen gesendet.",
    "reset_password_message_continue": "Möchtest du fortfahren?",
    "reset_password_success": "Der Link zum Zurücksetzen des Passworts wurde erfolgreich an ausgewählte Personen gesendet"
  },
  "sso": {
    "title": "SSO aktivieren",
    "confirm": "Dadurch wird SSO für die ausgewählten Personen aktiviert.",
    "continue": "Möchten Sie fortfahren?",
    "success": "SSO wurde erfolgreich für ausgewählte Personen aktiviert"
  },
  "sso_disable": {
    "title": "SSO deaktivieren",
    "confirm": "Die ausgewählten Benutzer könnten sich nicht mehr über Single Sign On anmelden und müssten sich mit einem Passwort authentifizieren.",
    "continue": "Möchten Sie fortfahren?",
    "success": "SSO wurde für ausgewählte Personen erfolgreich deaktiviert"
  },
  "removeFromTeamMessage1": "Diese Person wird nicht mehr Teil des Teams sein und verliert alle mit diesem Team verbundenen Anzeige- und Bearbeitungsberechtigungen.",
  "removeFromTeamMessage2": "Sind Sie sicher, dass Sie fortfahren möchten?",
  "removeFromTeamTitle": "Entferne diese Person aus dem Team",
  "removeFromTeamOverflowOption": "Aus dem Team entfernen",
  "createANewTeam": "Erstelle ein neues Team",
  "nameOfTeam": "Name des Teams",
  "createNewTeam": "Neues Team erstellen",
  "teamLeader": "Teamleiter",
  "toasts": {
    "add_team_success": "Team erfolgreich erstellt",
    "add_team_error": "Team konnte nicht erstellt werden",
    "invite_success": "Einladung (en) wurde (n) erfolgreich gesendet",
    "invite_error": "Einladung konnte nicht gesendet werden, weil {{ reason }}",
    "removeFromTeamSuccess": "Erfolgreich aus dem Team entfernt",
    "removeFromTeamError": "Aus dem Team konnte nicht entfernt werden",
    "setTeamLeaderSuccess": "Der Status des Teamleiters wurde erfolgreich festgelegt",
    "setTeamLeaderError": "Der Status des Teamleiters konnte nicht festgelegt werden",
    "deleteTeamSuccess": "Das Team wurde erfolgreich gelöscht",
    "deleteTeamError": "Team konnte nicht gelöscht werden"
  },
  "amount_teams_selected": "{{ amount }} Ausgewählte Teams",
  "invalid_email_address": "Ungültige E-Mail-Adresse",
  "one_or_more_email_not_valid": "Eine oder mehrere E-Mails sind nicht gültig",
  "select_one_team": "Bitte wählen Sie ein oder mehrere Teams aus",
  "deleteTeamTitle": "Team löschen",
  "deleteTeamMessage": "Bist du sicher, dass du das Team löschen möchtest: {{ team }}"
}